<template>
  <span class="card" @click="$emit('show-card', item.id)" style="line-height: 1.2rem">
    <label class="d-flex label justify-space-between">
      <a-view-table-select v-if="item.type == 'auto'" :value="item.type" :model="{ type: 'select', options: 'tasksType' }" />
      <a-view-table-select v-if="item.is_important" :value="item.is_important" :model="{ type: 'select', options: 'models.tasks.priority' }" />

      <small class="pl-2"> {{ getStatusDate(item) }} </small>
    </label>
    <label class="label d-flex">
      <small class="task-id pl-1" @click.stop="clickId(item)">#{{ item.id }}</small>
      <v-badge :value="item.unviewedscomments_total" :content="item.unviewedscomments_total" inline color="green"> </v-badge>
      <div v-if="item.files" class="pl-2" style="">
        <v-icon style="font-size: 18px; vertical-align: baseline">fas fa-paperclip</v-icon>
      </div>
      <div v-if="item.date_start < d_start" class="pl-2" style="">
        <v-icon style="font-size: 18px; vertical-align: baseline">far fa-clock</v-icon>
      </div>
      <div class="pl-2 justify-space-between" style="">
        <v-icon style="font-size: 18px; vertical-align: baseline">
          {{ item.is_private !== 2 ? "mdi-clock-in" : item.is_private === 2 ? "far fa-calendar-check" : "" }}
        </v-icon>
      </div>
      <small style="margin-left: auto" :style="new Date(item.date_end) < new Date() ? 'color: red' : ''">
        {{ item.date_start.asDate() }} - {{ item.date_end.asDate() }}
      </small>
      <small v-if="false" class="pl-2"> {{ getStatusDate(item) }} </small>
    </label>

    <label class="label">
      <div class="d-flex">
        <v-icon style="font-size: 14px; padding-right: 12px" :color="item.user_id ? 'green' : 'red'">far fa-user</v-icon>
        <a-view-table-select v-if="item.user_id" :value="item.user_id" :model="{ type: 'select', dir: 'user' }" />
      </div>
    </label>
    <small v-if="false" :style="new Date(item.date_end) < new Date() ? 'color: red' : ''"> {{ item.date_start.asDate() }} - {{ item.date_end.asDate() }} </small>
    <small v-if="item.object_name"> <v-icon style="font-size: 18px; margin-right: 5px">far fa-building</v-icon>{{ item.object_name }}</small>
    <div class="kanban-action">
      <label>
        <strong><a-view-taskname :value="item.name" :values="item" /></strong>
      </label>
    </div>
  </span>
</template>

<script>
import { getAccess, autoHeightBlock, genModel } from "@/components/mixings";
export default {
  mixins: [getAccess, autoHeightBlock, genModel],
  props: {
    item: Object,
    d_start: String,
  },
  components: {},
  data() {
    return {
      lazy: false,
      m: this.$store.getters["config/get"].models.tasks,
      load_action: 0,
      actions_: [],
      load_task: 0,
      tasks_: [],
    };
  },

  computed: {
    type() {
      return this.m?.type;
    },
    tasks() {
      let res = [];
      if (!this.load_task) {
        this.getTasks();
      }
      if (this.load_task == 2) res = this.tasks_;
      return res;
    },
    actions() {
      let res = [];
      if (!this.load_action) {
        this.getLastAction();
      }
      if (this.load_action == 2) res = this.actions_;
      return res;
    },
  },
  watch: {
    "item.updatedon"() {
      this.load_task = 0;
      this.load_action = 0;
    },
  },
  mounted() {},
  methods: {
    getStatusDate(item) {
      // return null;
      const res = (item?.status_history || []).find((s) => s.value == item.status);
      if (res) return res.createdon.asDate();
      return null;
    },
    clickId(e) {
      console.log(e);
    },

    getTaskName(v) {
      return (this.type.find((t) => t.value == v) || {})?.text || v;
    },
    getActionName(v) {
      return (this.type.find((t) => t.value == v) || {})?.action_text || v;
    },
    async getTasks() {
      this.load_task = 1;
      try {
        const params = { filters: { lead_id: this.item.id, status: 1 } };
        let d = await this.$axios.get(this.m.tasks.api, { params });
        this.tasks_ = [...d.data.data];
        this.load_task = 2;
      } catch (error) {
        this.load_task = 3;
        // this.$root.$emit("show-info", { text: "Ошибка загрузки данных" });
      }
    },
    async getLastAction() {
      this.load_action = 1;
      try {
        const params = { sort: { key: "id", order: "DESC" }, filters: { lead_id: this.item.id }, pager: { limit: 1 } };
        let d = await this.$axios.get(this.m.actions.api, { params });
        this.actions_ = [...d.data.data];
        this.load_action = 2;
      } catch (error) {
        this.load_action = 3;
        // this.$root.$emit("show-info", { text: "Ошибка загрузки данных" });
      }
    },
  },
};
</script>

<style lang="scss">
label.label {
  align-items: center;
  span.lead-icon1 {
    position: absolute;
  }
  div.lead-id1 {
    position: relative;
    left: 35px;
  }
}
</style>
